import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { MaterialForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditMaterial({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const material = useSelector((state) => state.material);
  const materialType = useSelector((state) => state.materialType);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: material.name,
      unit: material.unit,
      net: material.net,
      unit_net: material.unit_net,
      detail: material.detail,
      type_code: material.type_code,
      minimum_amount: material.minimum_amount,
    },
  });

  useEffect(() => {
    dispatch(actions.materialGet(id));
    dispatch(actions.materialTypeAll(''));
    return () => { };
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      await dispatch(actions.materialPut(id, data));
      await dispatch(actions.materialGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };
  if (material.isLoading || material.rows) {
    return <Loading />;
  }
  if (!material.isLoading && material.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">แก้ไขข้อมูลวัตถุดิบ</div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaterialForm
                errors={errors}
                material={material}
                control={control}
                Controller={Controller}
                materialType={materialType}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button
                  variant="contained"
                  type="submit"
                  startIcon={<SaveIcon />}
                >
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditMaterial.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditMaterial.defaultProps = {
  title: '',
  subtitle: '',
};
